import React, { useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

export default function SecuritySettings() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    setSaving(true);
    try {
      await api.post("/me/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setCurrent(""); setNext("");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  return (
    <div className="space-y-8" data-testid="security-settings">
      <div>
        <h2 className="text-xl font-medium text-zinc-50" style={{ fontFamily: "var(--font-heading)" }}>Security</h2>
        <p className="text-sm text-zinc-500 mt-1">Manage how you sign in to Milkath.</p>
      </div>
      <form onSubmit={submit} className="space-y-5 max-w-md">
        <div>
          <label className="text-xs font-medium text-zinc-400">Current password</label>
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required className="mt-1.5 w-full bg-zinc-900 border border-zinc-800 rounded-lg px-3 py-2 text-sm text-zinc-100 focus:outline-none focus:ring-2 focus:ring-orange-600/40 focus:border-orange-600" data-testid="security-current-input" />
        </div>
        <div>
          <label className="text-xs font-medium text-zinc-400">New password</label>
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} className="mt-1.5 w-full bg-zinc-900 border border-zinc-800 rounded-lg px-3 py-2 text-sm text-zinc-100 focus:outline-none focus:ring-2 focus:ring-orange-600/40 focus:border-orange-600" data-testid="security-new-input" />
        </div>
        <button type="submit" disabled={saving} className="bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white px-4 py-2 rounded-lg text-sm font-medium" data-testid="security-save-btn">
          {saving ? "Updating…" : "Update password"}
        </button>
      </form>
    </div>
  );
}
